/* =================== SLIDE HOME =================== */
$(function () {
  $(".carousel-slide").each(function () {
    // Elemento
    const $slide = $(this);

    // Total de itens no carrossel
    const totalItens = $slide.find(".splide__slide").length;

    // Intervalo
    let slideInterval = $slide.data("slide-interval") || 5000;

    // Opções gerais do slide
    let slideOpts = {
      type: "loop",
      perPage: 1,
      perMove: 1,
      speed: 600,
      autoplay: true,
      interval: slideInterval,
      pauseOnHover: true,
      arrows: true,
      pagination: true,
      lazyLoad: "nearby",
      breakpoints: {
        // Mobile
        768: {
          arrows: false,
        },
      },
    };

    // Habilite o auto height (Altura automática com base em cada slide)
    if ($slide.hasClass("carousel-autoheight")) {
      slideOpts.autoHeight = true;
      slideOpts.updateOnMove = true;
    }

    // Exibe barra de progresso
    const showProgress = $slide.data("slide-progress");
    if (showProgress) {
      $slide.append(
        `<div class="splide__progress"><div class="splide__progress__bar"></div></div>`
      );
    }

    // Ajusta para quando houver apenas um item no carrossel
    if (totalItens === 1) {
      slideOpts.type = "slide";
      slideOpts.arrows = false;
      slideOpts.pagination = false;
      slideOpts.drag = false;
      slideOpts.autoplay = false;
      slideOpts.keyboard = false;
    }

    // Inicia o slide
    let slide = new Splide($slide[0], slideOpts);

    // Configuração das animações
    function applyAnimationsSlide(index) {
      document.querySelectorAll("[data-slide-animation]").forEach((el) => {
        el.style.opacity = "0";
        el.classList.remove(el.dataset.slideAnimation);
      });
      let nextSlide = slide.Components.Elements.slides[index];
      if (nextSlide) {
        nextSlide.querySelectorAll("[data-slide-animation]").forEach((el) => {
          let customDelay = parseInt(el.dataset.slideAnimationDelay) || 0;
          let finalDelay = 500 + customDelay;
          setTimeout(() => {
            el.style.opacity = "1";
            el.classList.add(el.dataset.slideAnimation);
          }, finalDelay);
        });
      }
    }
    // Aplica a animação sempre que mudar de slide
    slide.on("move", (newIndex) => {
      applyAnimationsSlide(newIndex);
    });
    // Aplica a animação no primeiro slide ao carregar
    slide.on("mounted", () => applyAnimationsSlide(0));

    // Monta o slide
    slide.mount();
  });
});

document.addEventListener('DOMContentLoaded', function () {

  let radioWindow = null; // controla a janela

  document.querySelectorAll('.btn-abrir-radio').forEach(function(btn) {

    btn.addEventListener('click', function () {

      // Se já existe e está aberta → só foca nela
      if (radioWindow && !radioWindow.closed) {
        radioWindow.focus();
        return;
      }

      var largura = 600;
      var altura = 420;

      var left = (screen.width / 2) - (largura / 2);
      var top = (screen.height / 2) - (altura / 2);

      radioWindow = window.open('', 'radioPlayer', `
        width=${largura},
        height=${altura},
        top=${top},
        left=${left},
        resizable=no
      `);

      // Escreve o conteúdo apenas uma vez
      radioWindow.document.write(`
        <html>
          <head>
            <title>Rádio Louvor Livre</title>
            <style>
              body {
                margin: 0;
                background: #1B1A17;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            </style>
          </head>
          <body>
            <iframe 
              src="https://public-player-widget.webradiosite.com/?cover=1&current_track=1&schedules=1&link=1&popup=1&share=1&embed=0&auto_play=0&source=10002&theme=light&color=2&link_to=https%3A%2F%2Fradiolouvorlivre.com.br%2F&identifier=Radio%20Louvor%20Livre&info=https%3A%2F%2Fpublic-player-widget.webradiosite.com%2Fapp%2Fplayer%2Finfo%2F252975%3Fhash%3D7d33b931ffd0117cf3c6f7c0beaadc8c83d8d127&locale=pt-br"
              width="80%"
              height="165"
              frameborder="0"
              allow="autoplay; clipboard-write"
            ></iframe>
          </body>
        </html>
      `);

      radioWindow.document.close();

    });

  });

});
